import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { setClientRating } from "../../../../../store/slices/ratingSlice";
import {
  getClientRatingData,
  getsingleClientRatingData,
} from "../../../../../store/slices/clientRatingDashboardSliceL3";
import {
  setClientFilterRedux,
  setGroupFilterRedux,
  setPotentialFromDateRedux,
  setPotentialStatusRedux,
  setPotentialToDateRedux,
  setProbabilityFromDateRedux,
  setProbabilityToDateRedux,
  setSelectedYearsRedux,
  setSourceFromDateRedux,
  setSourceRedux,
  setSourceToDateRedux,
} from "../../../../../store/slices/filterSlice";
import { useDispatch, useSelector } from "react-redux";
import { ValidDate } from "../../../../../utils/DateUtils";
// import { logoutSession } from "../../../../../store/slices/sessionSlice";
// import { useNavigate } from "react-router-dom";
// import { useSnackbar } from "notistack";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { MdLogout } from "react-icons/md";
// import { FaUserCircle } from "react-icons/fa";
import {
  setFilteredReports,
  setFollowupReports,
  setNewfilteredReports,
} from "../../../../../store/slices/filteredDataSlice";
import DashStatusCards from "./DashStatusCards";
import { setCurrentPageTitle } from "../../../../../store/slices/pageSlice";

const DashFilters = ({ wrapperClasses, showFilterBar = true }) => {

  const [clientName, setclientName] = useState("");
  const [reduxLeads, setReduxLeads] = useState([]);
  const [filteredLeadReports, setFilteredLeadReports] = useState([]);
  const [newLeadReports, setnewLeadReports] = useState([]);
  const [tableLeadReports, setTableLeadReports] = useState([]);
  const [LeadReports, setLeadReports] = useState([]);
  const [GroupNames, setGroupNames] = useState([]);
  const [groupName, setgroupName] = useState("");
  const dispatch = useDispatch();

  const { group } = useSelector((state) => state.group);
  const { leads } = useSelector((state) => state.leads);
  const groupNameById = useMemo(() => {
    const normalize = (value) => String(value ?? "").trim();
    const map = new Map();
    const groups = Array.isArray(group) ? group : [];
    groups.forEach((item) => {
      const id = normalize(item?._id ?? item?.id);
      if (!id) return;
      const name = normalize(
        item?.name ??
        item?.newGroupName ??
        item?.groupName ??
        item?.GroupName ??
        id
      );
      map.set(id, name || id);
    });
    return map;
  }, [group]);
  const groupIdByName = useMemo(() => {
    const map = new Map();
    groupNameById.forEach((name, id) => {
      const key = String(name ?? "").trim();
      if (key) map.set(key, id);
    });
    return map;
  }, [groupNameById]);
  const resolveGroupName = useCallback((lead) => {
    const normalize = (value) => String(value ?? "").trim();
    const groupIdFromObject = normalize(lead?.groupid?._id ?? lead?.groupid?.id);
    if (groupIdFromObject && groupNameById.has(groupIdFromObject)) {
      return groupNameById.get(groupIdFromObject);
    }
    const groupIdFromString = typeof lead?.groupid === "string" ? normalize(lead.groupid) : "";
    if (groupIdFromString && groupNameById.has(groupIdFromString)) {
      return groupNameById.get(groupIdFromString);
    }
    return normalize(
      lead?.AssignedGroupName ??
      lead?.AssignedGroup ??
      lead?.groupid?.name ??
      groupIdFromString
    );
  }, [groupNameById]);

  const clientRating = useSelector(
    (state) => state.ratingsfilter?.clientRatings || "0"
  );

  useEffect(() => {
    dispatch(setFilteredReports(filteredLeadReports || []));

    if (newLeadReports) {
      dispatch(setNewfilteredReports(newLeadReports));
    }
    if (tableLeadReports) {
      dispatch(setFollowupReports(tableLeadReports));
    }
  }, [dispatch, filteredLeadReports, newLeadReports, tableLeadReports]);

  useEffect(() => {
    if (clientRating !== undefined && clientRating !== null) {
      setClientData(clientRating);
    }
  }, [clientRating, clientName, groupName, dispatch]);

  useEffect(() => {
    setGroupNames(group);
  }, [group]);

  useEffect(() => {
    const leadsCopy = [...leads]; // ✅ Create a copy before modifying
    setReduxLeads(leadsCopy);
    setLeadReports(leadsCopy);
  }, [leads]);

  // Follow-up table only: Pending / Won Recurring. Do NOT write filteredLeadReports here —
  // that feeds the status cards and would briefly show incomplete counts.
  useEffect(() => {
    if (!reduxLeads || reduxLeads.length === 0) return;

    const currentYear = new Date().getFullYear();
    const twoYearsAgo = currentYear - 2;

    const normalizedData = reduxLeads
      .filter((lead) => lead.LeadDate) // ✅ Ensure LeadDate exists
      .map((lead) => ({
        ...lead,
        LeadDate: ValidDate(lead.LeadDate),
      }))
      .filter((lead) => {
        const leadYear = new Date(lead.LeadDate).getFullYear();
        return (
          leadYear >= twoYearsAgo &&
          (lead.Status === "Pending" || lead.Status === "Won Recurring")
        );
      });

    setTableLeadReports(normalizedData);
  }, [reduxLeads]);

  const dropdownRef = useRef(null);
  const dropdownRefGroup = useRef(null);
  const dropdownRefclient = useRef(null);

  const [showYearDropdown, setShowYearDropdown] = useState(false);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [showGroupDropdown, setShowGroupDropdown] = useState(false);

  const [selectedYears, setSelectedYears] = useState([]); // Store selected years
  console.log("year selectedYears", selectedYears);

  const currentYear = new Date().getFullYear();

  const years = useMemo(
    () => [
      currentYear,
      currentYear - 1,
      currentYear - 2,
      currentYear - 3,
      currentYear - 4,
    ],
    [currentYear]
  );
  useEffect(() => {
    dispatch(setCurrentPageTitle(`Lead Tracker Dashboard`));
  }, [dispatch]);
  const [clientFilter, setClientFilter] = useState("");
  const [groupFilter, setGroupFilter] = useState("");

  const [, setTodaysDate] = useState("");
  const [showLogout, setshowlogout] = useState(false);
  const popupRef = useRef(null);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setshowlogout(false); // Close the popup if clicked outside
    }
  };
  useEffect(() => {
    if (showLogout) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showLogout]);

  useEffect(() => { }, [tableLeadReports]);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setTodaysDate(today);
  }, []);

  useEffect(() => {
    setTableLeadReports(filteredLeadReports);
  }, [filteredLeadReports]);

  // Get filter value from Redux store
  const groupFilterRedux = useSelector((state) => state.filters.groupFilter);
  const ClientFilterRedux = useSelector((state) => state.filters.clientFilter);
  const YearsFilterRedux = useSelector((state) => state.filters.selectedYears);

  useEffect(() => {
    if (groupFilterRedux) {
      setGroupFilter(groupFilterRedux);
      setgroupName(groupFilterRedux);
    }
  }, [groupFilterRedux, dispatch]);

  useEffect(() => {
    if (ClientFilterRedux !== undefined && ClientFilterRedux !== null) {
      setclientName(ClientFilterRedux);
      setClientFilter(ClientFilterRedux);
    }
  }, [ClientFilterRedux]);

  useEffect(() => {
    if (YearsFilterRedux) {
      setSelectedYears(YearsFilterRedux);
    }
  }, [YearsFilterRedux]);

  useEffect(() => {
    let filteredData = [...LeadReports];
    if (clientFilter && clientFilter.trim() !== "") {
      filteredData = filteredData.filter(
        (lead) =>
          lead.ClientName.toLowerCase().trim() ===
          clientFilter.toLowerCase().trim()
      );
    }
    if (selectedYears && selectedYears.length > 0) {

      filteredData = filteredData.filter((lead) => {
        if (!lead.LeadDate) return false; // Skip if no LeadDate

        const leadYear = new Date(lead.LeadDate).getFullYear();

        return selectedYears.includes(leadYear);
      });
    }
    if (groupFilter && groupFilter.trim() !== "") {
      filteredData = filteredData.filter((lead) =>
        resolveGroupName(lead).toLowerCase().includes(groupFilter.toLowerCase())
      );
    }
    if (groupFilter === "All") {
      setGroupFilter("");
      setgroupName("");
    }
    if (clientFilter === "All") {
      setclientName("");
      setClientFilter("");
    }

    console.log("filteredDatfilteredDataa year", filteredData);
    setFilteredLeadReports(filteredData); // Update a new state variable for filtered data
  }, [selectedYears, LeadReports, clientFilter, groupFilter, dispatch, resolveGroupName]);

  useEffect(() => {
    let filteredData = [...LeadReports];

    if (clientFilter && clientFilter.trim() !== "") {
      filteredData = filteredData.filter(
        (lead) =>
          lead.ClientName.toLowerCase().trim() ===
          clientFilter.toLowerCase().trim()
      );
    }
    if (groupFilter && groupFilter.trim() !== "") {
      filteredData = filteredData.filter((lead) =>
        resolveGroupName(lead).toLowerCase().includes(groupFilter.toLowerCase())
      );
    }
    if (groupFilter === "All") {
      setGroupFilter("");
      setgroupName("");

    }
    if (clientFilter === "All") {
      setclientName("");
      setClientFilter("");
    }
    setnewLeadReports(filteredData); // Update a new state variable for filtered data
  }, [selectedYears, LeadReports, clientFilter, groupFilter, dispatch, resolveGroupName]);

  useEffect(() => { }, [newLeadReports, filteredLeadReports]);

  const handleInputChange = useCallback(
    (groupFilter) => {
      setgroupName(groupFilter);
      setGroupFilter(groupFilter);
      setSelectedYears([]);
      setShowGroupDropdown(false);

      dispatch(setGroupFilterRedux(groupFilter));
      dispatch(setSelectedYearsRedux([]));

      dispatch(setPotentialFromDateRedux(""));
      dispatch(setPotentialToDateRedux(""));
      dispatch(setPotentialStatusRedux("All"));

      dispatch(setProbabilityFromDateRedux(""));
      dispatch(setProbabilityToDateRedux(""));

      dispatch(setSourceFromDateRedux(""));
      dispatch(setSourceToDateRedux(""));
      dispatch(setSourceRedux("All"));
    },
    [dispatch, setGroupFilter, setgroupName]
  );

  const handleClientChange = useCallback(
    (clientValue) => {
      setclientName(clientValue);
      setClientFilter(clientValue);
      setSelectedYears([]);
      setShowClientDropdown(false);
      dispatch(setClientFilterRedux(clientValue));

      dispatch(setPotentialFromDateRedux(""));
      dispatch(setPotentialToDateRedux(""));
      dispatch(setPotentialStatusRedux("All"));

      dispatch(setProbabilityFromDateRedux(""));
      dispatch(setProbabilityToDateRedux(""));

      dispatch(setSourceFromDateRedux(""));
      dispatch(setSourceToDateRedux(""));
      dispatch(setSourceRedux("All"));
    },
    [setClientFilter, setclientName, dispatch]
  );

  const handleYearSelection = (event) => {
    const selectedValue = parseInt(event.target.value);

    setSelectedYears((prev) => {
      const updatedYears = event.target.checked
        ? [...prev, selectedValue] // Add year if checked
        : prev.filter((yr) => yr !== selectedValue); // Remove year if unchecked

      dispatch(setSelectedYearsRedux(updatedYears)); // Dispatch the updated array to Redux store

      dispatch(setPotentialFromDateRedux(""));
      dispatch(setPotentialToDateRedux(""));
      dispatch(setPotentialStatusRedux("All"));

      dispatch(setProbabilityFromDateRedux(""));
      dispatch(setProbabilityToDateRedux(""));

      dispatch(setSourceFromDateRedux(""));
      dispatch(setSourceToDateRedux(""));
      dispatch(setSourceRedux("All"));
      return updatedYears;
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowYearDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefGroup.current &&
        !dropdownRefGroup.current.contains(event.target)
      ) {
        setShowGroupDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefclient.current &&
        !dropdownRefclient.current.contains(event.target)
      ) {
        setShowClientDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => { }, [clientName, groupName]);

  const [clientData, setClientData] = useState({
    starRating: "0",
  });

  const getRatingValueFromRows = useCallback((rows, groupId, groupLabel) => {
    if (!Array.isArray(rows) || rows.length === 0) return null;

    const byGroup = new Map();
    rows.forEach((item) => {
      if (!item || item.message) return;
      const rid = String(item.groupid?._id ?? item.groupid ?? "").trim();
      const gname = String(item.groupName ?? "").trim();
      const key = rid || gname || "__none";
      const n = Number(item.TotalRating);
      if (!Number.isFinite(n) || n <= 0) return;
      if (!byGroup.has(key)) byGroup.set(key, n);
    });

    const gid = String(groupId ?? "").trim();
    const label = String(groupLabel ?? "").trim();
    if (gid || (label && label !== "All")) {
      for (const [key, val] of byGroup) {
        if ((gid && key === gid) || (label && key === label)) return val;
      }
      const match = rows.find((item) => {
        const rid = String(item.groupid?._id ?? item.groupid ?? "").trim();
        const gname = String(item.groupName ?? "").trim();
        return (gid && rid === gid) || (label && gname === label);
      });
      const n = Number(match?.TotalRating);
      return Number.isFinite(n) && n > 0 ? n : null;
    }

    const values = [...byGroup.values()];
    if (!values.length) return null;
    return values.reduce((sum, n) => sum + n, 0) / values.length;
  }, []);

  useEffect(() => {
    const fetchLead = async () => {
      const selectedClient = String(clientName ?? "").trim();
      const selectedGroup = String(groupName ?? "").trim();
      const hasGroup = Boolean(selectedGroup && selectedGroup !== "All");

      if (!selectedClient || selectedClient === "All") {
        setClientData({ starRating: "0" });
        dispatch(setClientRating({ starRating: "0" }));
        return;
      }

      try {
        let rows = [];
        const gid = hasGroup
          ? groupIdByName.get(selectedGroup) || selectedGroup
          : "";

        if (hasGroup) {
          const response = await dispatch(
            getClientRatingData({
              clientName: selectedClient,
              groupName: gid,
            })
          ).unwrap();

          if (response?.message !== "No ratings found" && Array.isArray(response)) {
            rows = response;
          }

          if (!rows.length) {
            const all = await dispatch(
              getsingleClientRatingData(selectedClient)
            ).unwrap();
            rows = Array.isArray(all) ? all : [];
          }
        } else {
          const response = await dispatch(
            getsingleClientRatingData(selectedClient)
          ).unwrap();

          if (response?.message === "No ratings found") {
            setClientData({ starRating: "0" });
            dispatch(setClientRating({ starRating: "0" }));
            return;
          }
          rows = Array.isArray(response) ? response : [];
        }

        const value = getRatingValueFromRows(
          rows,
          hasGroup ? gid : "",
          hasGroup ? selectedGroup : ""
        );
        const starRating = value ? Number(value).toFixed(1) : "0";
        setClientData({ starRating });
        dispatch(setClientRating({ starRating }));
      } catch (error) {
        console.error("Error fetching lead data:", error);
        setClientData({ starRating: "0" });
        dispatch(setClientRating({ starRating: "0" }));
      }
    };

    fetchLead();
  }, [
    clientName,
    groupName,
    dispatch,
    groupIdByName,
    getRatingValueFromRows,
  ]);

  interface StarRatingProps {
    rating?: number;
  }
  const StarRating: React.FC<StarRatingProps> = ({ rating }) => {

    if (rating === undefined || rating === null) return null; // Prevent rendering if rating is invalid

    // Normalize the rating to a 5-star system
    const normalizedRating = rating > 5 ? (rating / 10) * 5 : rating;
    const safeRating = Math.min(Math.max(normalizedRating, 0), 5); // Ensure within range

    const fullStars = Math.floor(safeRating);
    const decimalPart = safeRating - fullStars; // Extract decimal part
    const hasHalfStar = decimalPart >= 0.5; // Show half-star if decimal part is 0.5 or more
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0); // Ensure total is 5
    const starColor =
      Number(rating) >= 4 ? "text-green-500" : "text-yellow-500";

    return (
      <div className={`flex items-center ${starColor} text-3xl`}>
        {Array(fullStars)
          .fill(null)
          .map((_, i) => (
            <FaStar key={i} />
          ))}
        {hasHalfStar && <FaStarHalfAlt key="half-star" />}
        {Array(emptyStars)
          .fill(null)
          .map((_, i) => (
            <FaRegStar key={`empty-${i}`} />
          ))}
      </div>
    );
  };

  const [filteredClientNames, setClientNames] = useState([]);
  console.log("filteredClientNames", filteredClientNames)
  
  useEffect(() => {
    if (!LeadReports || LeadReports.length === 0) {
      setClientNames([]);
      return;
    }

    let data = [...LeadReports];

    // 🔹 Group filter
    if (groupFilter && groupFilter !== "All") {
      data = data.filter(
        (lead) => resolveGroupName(lead) === groupFilter
      );
    }
    if (selectedYears && selectedYears.length > 0) {
      data = data.filter((lead) => {
        const leadYear = new Date(lead.LeadDate).getFullYear();
        return selectedYears.includes(leadYear);
      });
    }
    // 🔹 Sort only when no specific group filter
    if (!groupFilter || groupFilter === "") {
      data = data.sort((a, b) =>
        a.ClientName.trim().localeCompare(b.ClientName.trim())
      );
    }

    // 🔹 Remove duplicate ClientName (case-insensitive)
    const uniqueData = data.reduce((acc, lead) => {
      const existingIndex = acc.findIndex(
        (item) =>
          item.ClientName.toLowerCase() ===
          lead.ClientName.toLowerCase()
      );

      if (existingIndex === -1) {
        acc.push(lead);
      } else {
        acc[existingIndex] =
          acc[existingIndex].ClientName ===
            acc[existingIndex].ClientName.toUpperCase()
            ? acc[existingIndex]
            : lead;
      }

      return acc;
    }, []);

    setClientNames(uniqueData);
  }, [LeadReports, groupFilter, selectedYears, resolveGroupName]);


  return (
    <div className="w-full p-0 ">
      <div className="w-full">
        <div className=" row-span-1 col-start-2 col-span-1 ">
          <div className="  bg-white w-full flex items-center top-4 py-2 rounded-b-md">
            <div className="flex flex-col w-full">
              <div className="relative flex w-full items-center justify-between space-x-2">
                {showFilterBar && (
                <div className="flex items-center space-x-2">
                  <div className="flex gap-2 align-middle items-center scale-90">
                    <h1 className="font-semibold ">GROUP</h1>

                    <div className=" ">
                      <div
                        ref={dropdownRefGroup}
                        className="relative flex  border p-0  rounded-md  align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className="absolute cursor-pointer right-2 m-auto bg-white"
                          onClick={() =>
                            setShowGroupDropdown(!showGroupDropdown)
                          }
                        />

                        <button
                          type="button"
                          onClick={() =>
                            setShowGroupDropdown(!showGroupDropdown)
                          }
                          className=" text-sm text-left rounded-md  outline-none text-nowrap truncate p-2 w-40"
                        >
                          {groupFilter ? groupFilter : <p>Select Group</p>}
                        </button>

                        {showGroupDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute top-full max-w-60  left-0 w-full max-h-64 cursor-pointer overflow-y-auto bg-gray-100 text-sm border border-gray-300 shadow-lg flex flex-col"
                          >
                            <div
                              className="p-2 hover:bg-gray-200 cursor-pointer"
                              onClick={() => handleInputChange("All")}
                            >
                              All
                            </div>
                            {[...GroupNames].sort((a, b) =>
                              String(a?.name ?? a?.newGroupName ?? a?.groupName ?? "").localeCompare(
                                String(b?.name ?? b?.newGroupName ?? b?.groupName ?? "")
                              )
                            )
                              .map((group) => (
                                <div
                                  className="p-2 hover:bg-gray-200 text-wrap cursor-pointer"
                                  onClick={() =>
                                    handleInputChange(
                                      String(
                                        group?.name ??
                                        group?.newGroupName ??
                                        group?.groupName ??
                                        ""
                                      )
                                    )
                                  }
                                  key={group?._id ?? group?.id}
                                  value={group?.name ?? group?.newGroupName ?? group?.groupName}
                                >
                                  {group?.name ?? group?.newGroupName ?? group?.groupName}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-2 align-middle items-center scale-90">
                    <h1 className="font-semibold">CLIENT</h1>

                    <div ref={dropdownRefclient} className="relative">
                      <div className="flex  p-0 border rounded-md align-middle items-center">
                        <ExpandMoreIcon
                          className="absolute right-1 cursor-pointer bg-white"
                          onClick={() =>
                            setShowClientDropdown(!showClientDropdown)
                          }
                        />

                        <button
                          type="button"
                          onClick={() =>
                            setShowClientDropdown(!showClientDropdown)
                          }
                          className=" text-left text-sm outline-none p-2 text-nowrap truncate w-40"
                        >
                          {clientFilter ? clientFilter : <p>Select Client</p>}
                        </button>
                      </div>

                      {showClientDropdown && (
                        <div

                          style={{ zIndex: 9999 }}
                          className="absolute top-full  left-0 w-full max-h-64 cursor-pointer overflow-y-auto bg-gray-100 text-sm border border-gray-300 shadow-lg"
                        >
                          <p
                            className="p-2 hover:bg-gray-200 "
                            onClick={() => {
                              handleClientChange("All");
                            }}
                          >
                            All
                          </p>
                          {filteredClientNames.map((lead) => (
                            <p
                              key={lead.id}
                              className="p-2 hover:bg-gray-200"
                              onClick={() => handleClientChange(lead.ClientName)}
                            >
                              {lead.ClientName}
                            </p>
                          ))}

                          {/* {groupFilter !== ""
                            ? LeadReports.filter(
                              (lead) => lead.AssignedGroup === groupFilter
                            )
                              .reduce((acc, lead) => {
                                const existingIndex = acc.findIndex(
                                  (item) =>
                                    item.ClientName.toLowerCase() ===
                                    lead.ClientName.toLowerCase()
                                );

                                if (existingIndex === -1) {
                                  acc.push(lead);
                                } else {
                                  acc[existingIndex] =
                                    acc[existingIndex].ClientName ===
                                      acc[
                                        existingIndex
                                      ].ClientName.toUpperCase()
                                      ? acc[existingIndex]
                                      : lead;
                                }
                                return acc;
                              }, [])
                              .map((lead) => (
                                <p
                                  className="p-2 hover:bg-gray-200"
                                  onClick={() =>
                                    handleClientChange(lead.ClientName)
                                  }
                                  key={lead.id}
                                  value={lead.ClientName}
                                >
                                  {lead.ClientName}
                                </p>
                              ))
                            : groupFilter === "All"
                              ? LeadReports.reduce((acc, lead) => {
                                const existingIndex = acc.findIndex(
                                  (item) =>
                                    item.ClientName.toLowerCase() ===
                                    lead.ClientName.toLowerCase()
                                );

                                if (existingIndex === -1) {
                                  acc.push(lead);
                                } else {
                                  acc[existingIndex] =
                                    acc[existingIndex].ClientName ===
                                      acc[existingIndex].ClientName.toUpperCase()
                                      ? acc[existingIndex]
                                      : lead;
                                }
                                return acc;
                              }, []).map((lead) => (
                                <p
                                  className="p-2 hover:bg-gray-200 "
                                  onClick={() =>
                                    handleClientChange(lead.ClientName)
                                  }
                                  key={lead.id}
                                  value={lead.ClientName}
                                >
                                  {lead.ClientName}
                                </p>
                              ))
                              : LeadReports.sort((a, b) =>
                                a.ClientName.trim().localeCompare(
                                  b.ClientName.trim()
                                )
                              )
                                .reduce((acc, current) => {
                                  const existingIndex = acc.findIndex(
                                    (item) =>
                                      item.ClientName.toLowerCase() ===
                                      current.ClientName.toLowerCase()
                                  );

                                  if (existingIndex === -1) {
                                    acc.push(current);
                                  } else {
                                    acc[existingIndex] =
                                      acc[existingIndex].ClientName ===
                                        acc[
                                          existingIndex
                                        ].ClientName.toUpperCase()
                                        ? acc[existingIndex]
                                        : current;
                                  }
                                  return acc;
                                }, [])
                                .map((lead) => (
                                  <p
                                    className="p-2 hover:bg-gray-200 "
                                    onClick={() => {
                                      handleClientChange(lead.ClientName);
                                    }}
                                    key={lead.id}
                                    value={lead.ClientName}
                                  >
                                    {lead.ClientName}
                                  </p>
                                ))} */}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Year SELECTOR */}
                  <div className=" flex gap-2 align-middle items-center scale-90">
                    <h1 className="font-semibold">YEAR</h1>

                    <div className=" ">
                      <div
                        ref={dropdownRef}
                        className="relative flex  p-0  rounded-md border  align-middle items-center"
                      >
                        <ExpandMoreIcon
                          color="white"
                          className="absolute right-0 border-r border-gray-300 m-auto cursor-pointer bg-white"
                          onClick={() => setShowYearDropdown(!showYearDropdown)}
                        />

                        <button
                          type="button"
                          onClick={() => setShowYearDropdown(!showYearDropdown)}
                          className=" text-left text-sm rounded-md  outline-none p-2 text-nowrap overflow-hidden w-40"
                        >
                          {selectedYears.length > 0
                            ? selectedYears.join(", ")
                            : "Select Year"}
                        </button>

                        {showYearDropdown && (
                          <div
                            style={{ zIndex: 9999 }}
                            className="absolute -bottom-44 w-full bg-gray-100 text-sm border border-gray-300 shadow-lg"
                          >
                            {years.map((year) => (
                              <label
                                key={year}
                                className="flex items-center px-4 py-2 hover:bg-blue-400 cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  value={year}
                                  checked={selectedYears.includes(year)}
                                  onChange={handleYearSelection} // Use function here
                                  className="mr-2"
                                />
                                {year}
                              </label>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div>
                    {clientData &&
                      clientData.starRating > 0 && ( // Only show stars if starRating is greater than 0
                        <>
                          <StarRating rating={clientData.starRating} />
                        </>
                      )}
                  </div>
                </div>
                )}

                {/* <div className="relative cursor-pointer mr-[2%] bg-transparent">
                  <FaUserCircle
                    onClick={logout}
                    className="text-black w-6 h-6"
                  />
                  {showLogout && (
                    <div
                      ref={popupRef}
                      className="absolute right-0 top-full mt-1 text-black text-center px-2 w-36 shadow-2xl overflow-hidden bg-white border border-gray-400 z-50 rounded-lg"
                    >
                      <h1 className="px-6 py-2 rounded-md my-1">{name}</h1>
                      <button
                        onClick={(e) => logoutUser(e)}
                        className="flex items-center gap-2 px-6 py-2 rounded-md my-1 cursor-pointer hover:bg-black hover:text-white"
                      >
                        <MdLogout size={24} /> Logout
                      </button>
                    </div>
                  )}
                </div> */}
              </div>
            </div>
          </div>
          <DashStatusCards />
        </div>
      </div>
    </div>
  );
};

export default DashFilters;
